<template>
  <div>
    <div class="common-seach-wrap">
      <el-form
        size="small"
        :inline="true"
        :model="searchForm"
        class="demo-form-inline"
      >
        <el-form-item label="审核状态">
          <el-select v-model="searchForm.supplier" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转账状态">
          <el-select v-model="searchForm.trans_status" placeholder="请选择">
            <el-option
              v-for="item in transoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div>
      <el-row>
        <el-col :span="6" class="d-c-c">
          <div class="grid-content">
            <img src="/src/assets/img/daishenhe.png" alt="" />
            <div class="info">
              <h1>0</h1>
              <p>待审核金额</p>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="d-c-c">
          <div class="grid-content">
            <img src="/src/assets/img/yizhuanzhang.png" alt="" />
            <div class="info">
              <h1>0</h1>
              <p>已转账金额</p>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="d-c-c">
          <div class="grid-content">
            <img src="/src/assets/img/daizhuanzhang.png" alt="" />
            <div class="info">
              <h1>0</h1>
              <p>待转账金额</p>
            </div>
          </div>
        </el-col>
        <el-col :span="6" class="d-c-c">
          <div class="grid-content">
            <img src="/src/assets/img/shibai.png" alt="" />
            <div class="info ">
              <h1>0</h1>
              <p>审核失败金额</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-table :data="tableData" border style="width: 100%">
      <el-table-column fixed prop="id" label="ID" width="150">
      </el-table-column>
      <el-table-column prop="title" label="城市信息" width="150">
      </el-table-column>
      <el-table-column prop="income" label="申请金额"> </el-table-column>
      <el-table-column prop="out" label="可得金额"> </el-table-column>
      <el-table-column prop="createTime" label="申请时间"> </el-table-column>
      <el-table-column prop="paytype" label="收款方式" width="150">
      </el-table-column>
      <el-table-column prop="collectinfo" label="收款信息" width="150">
      </el-table-column>
      <el-table-column prop="status_text" label="审核状态" width="150">
      </el-table-column>
      <el-table-column prop="trans_status" label="审核状态" width="150">
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="150">
        <template slot-scope="scope">
          <el-button type="primary" size="small">删除</el-button>
          <el-button type="danger" size="small" @click="editClick(scope.row)"
            >审核</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination
        @current-change="handleCurrentChange"
        background
        :current-page="curPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalDataNumber"
      ></el-pagination>
    </div>
    <Review
      v-if="open_review"
      :open_edit="open_review"
      :form="userModel"
      @closeDialog="closeDialogFunc($event, 'edit')"
    ></Review>
  </div>
</template>

<script>
import Review from "./review.vue";
import { deepClone } from "@/utils/base.js";
export default {
  components: {
    /*编辑组件*/
    Review
  },
  methods: {
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == "edit") {
        this.open_review = e.openDialog;
        if (e.type == "success") {
        }
      }
    },
    /*打开审核*/
    editClick(item) {
      this.userModel = deepClone(item);
      this.open_review = true;
    },
    handleClick(row) {
      console.log(row);
    },
    handleCurrentChange() {}
  },

  data() {
    return {
      userModel: {},
      open_review: false,
      activeName: "first",
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 1,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        createTime: "",
        trans_status: ""
      },
      options: [
        {
          value: "选项1",
          label: "审核通过"
        },
        {
          value: "选项2",
          label: "审核拒绝"
        },
        {
          value: "选项3",
          label: "待审核"
        }
      ],
      transoptions: [
        {
          value: "选项1",
          label: "已转账"
        },
        {
          value: "选项2",
          label: "未转账"
        }
      ],
      tableData: [
        {
          date: "2016-05-02",
          title: "测试",
          name: "王小虎",
          province: "上海",
          city: "普陀区",
          address: "上海市普陀区金沙江路 1518 弄",
          orderNo: 200333,
          matinfo: "毛巾",
          pay: "100",
          createTime: "2023年8月29日 12:33",
          order_status_text: "已完成",
          paytype: "微信",
          type: "申请入驻",
          remark: "好",
          id: 1,
          income: "888",
          out: "999",
          collectinfo: "15636369999",
          status_text: "已通过",
          status: 1,
          trans_status: "已转账"
        }
      ]
    };
  }
};
</script>
<style lang="scss">
.grid-content {
  display: flex;
  justify-content: start;
  align-items: center;
  width: 80%;
  margin-bottom: 50px;
  margin-top: 40px;
  img {
    margin-right: 40px;
  }
  p {
    color: rgba($color: #000000, $alpha: 0.6);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/citymanager/finance/transfer/index.vue